import React from 'react';
import ClientList from './ClientList';

const Clients = () => {
  return <ClientList />;
};

export default Clients;
